// src/lib/stack-app/email-templates/index.ts
function adminEmailTemplateUpdateOptionsToCrud(options) {
  return {
    subject: options.subject,
    content: options.content
  };
}
export {
  adminEmailTemplateUpdateOptionsToCrud
};
//# sourceMappingURL=index.js.map